import html from "html-literal";

export default () => html`
  <footer>

  <p>
          <h3><b>Contact Us</b></h3>
       <li>Email: KittyPinkCards@gmail.com</li>
        <li>Number: 636-431-4480</li>
        <li>Location: St. Louis Mo</li>

    </p>
    &copy; 2021 <a href="https://www.instagram.com/kittypinkcards/">KittyPinkCards</a>

    <div id="homeButton"><h5><a href="#">GOING UP</a></h5></div>

  </footer>
`;
